// MUI
import Box from '@mui/material/Box'

// Custom
import HeroSection from './sections/HeroSection'
import WhyMonitorSection from './sections/WhyMonitorSection'
import SolutionSection from './sections/SolutionSection'
import ActionSection from './sections/ActionSection'
import ApplicationsSection from './sections/ApplicationsSection'
import TailoredSection from './sections/TailoredSection'
import DeviceSection from './sections/DeviceSection'
import IncludedSection from './sections/IncludedSection'
import DashboardSection from './sections/DashboardSection'
import AlertsSection from './sections/AlertsSection'
import ShortTermSection from './sections/ShortTermSection'
import ScalingSection from './sections/ScalingSection'
import WhyUsSection from './sections/WhyUsSection'
import CtaSection from './sections/CtaSection'

// Style
import themeColors from 'assets/theme/colors'

export default function IotAirQualityMonitoringView() {
  // *** MAIN RENDER ***
  return (
    <Box sx={{ background: themeColors.kroemtech.background }}>
      {/* The hero is full bleed and carries the breadcrumbs itself, so it also
          owns the padding that clears the fixed header. */}
      <HeroSection />

      <WhyMonitorSection />
      <SolutionSection />
      <ActionSection />
      <ApplicationsSection />
      <TailoredSection />
      <DeviceSection />
      <IncludedSection />
      <DashboardSection />
      <AlertsSection />
      <ShortTermSection />
      <ScalingSection />
      <WhyUsSection />
      <CtaSection />
    </Box>
  )
}
